export default __webpack_public_path__ + "static/media/pan-preview-icon.ab6b3a9a.svg";